import * as types from '../mutation-types';

export const namespaced = true;

// state
export const state = {
  toastQueue: [],
  toastColor: 'primary',
  toastMessage: '',
  showToast: false,
  toastMultiLine: false,
};

// mutations
export const mutations = {
  [types.ADD_TO_TOAST_QUEUE](state, value) {
    state.toastQueue.push(value);
  },
  [types.SHOW_TOAST](state, value) {
    state.showToast = value;
  },
  [types.SET_TOAST_COLOR](state, value) {
    state.toastColor = value;
  },
  [types.SET_TOAST_MESSAGE](state, value) {
    state.toastMessage = value;
  },
  [types.SET_TOAST_MULTILINE](state, value) {
    state.toastMultiLine = value;
  },
};

// actions
export const actions = {

  addToGlobalToastQueue({ commit, state, dispatch }, payload) {
    payload.multiline = payload.multiline ? payload.multiline : false;
    if (!state.showToast) {
      dispatch('setGlobalToast', payload);
    } else {
      commit(types.ADD_TO_TOAST_QUEUE, payload);
    }
  },

  setGlobalToast({ commit }, payload) {
    commit(types.SHOW_TOAST, true);
    commit(types.SET_TOAST_COLOR, payload.color);
    commit(types.SET_TOAST_MESSAGE, payload.message);
    commit(types.SET_TOAST_MULTILINE, payload.multiline);
  },

  hideGlobalToast({ commit, state, dispatch }) {
    commit(types.SHOW_TOAST, false);
    if (state.toastQueue.length > 0) {
      const firstToast = state.toastQueue.shift();
      setTimeout(() => {
        dispatch('setGlobalToast', firstToast);
      }, 300);
    }
  },
};

// getters
export const getters = {
  toastColor: state => state.toastColor,
  toastMessage: state => state.toastMessage,
  showToast: state => state.showToast,
  toastMultiLine: state => state.toastMultiLine,
};
